import Patrimonio from "./Patrimonio";
import EmprestimoPatrimonio from "./EmprestimoPatrimonio";
import { BaseEditModel } from "model/BaseEditModel";
import Produto from "model/administracao/cadastro/produto/Produto";
import Estoque from "model/suprimentos/Estoque";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import Deposito from "model/suprimentos/Deposito";
import LoteItemEmprestimo from "./LoteItemEmprestimo";

export default class ItemEmprestimo implements BaseEditModel {

    id: number;
    key: string = "";
	sequencial: number;
    status: string;
    inutilizavel: boolean;
    itemProduto: boolean;
    dataEmprestimo: Date | null;
    dataDevolucao: Date | null;
    patrimonio: Patrimonio | null;
    emprestimoPatrimonio: EmprestimoPatrimonio;
    observacaoInutilizavel: string;
    quantidadeEmprestada: number;
    produto: Produto | null;
    lotes: LoteItemEmprestimo[];

    constructor(
        id = 0,
        sequencial = 0,
        status = "CRIADO",
        inutilizavel = false,
        itemProduto = false,
        dataEmprestimo = null,
        dataDevolucao = null,
        patrimonio = new Patrimonio(),
        emprestimoPatrimonio = new EmprestimoPatrimonio,
        observacaoInutilizavel = '',
        quantidadeEmprestada = 0,
        produto = null,
        lotes = []
    ){
        this.id = id;
        this.sequencial = sequencial;
        this.status = status;
        this.inutilizavel = inutilizavel;
        this.itemProduto = itemProduto;
        this.dataEmprestimo = dataEmprestimo;
        this.dataDevolucao = dataDevolucao;
        this.patrimonio = patrimonio;
        this.emprestimoPatrimonio = emprestimoPatrimonio;
        this.observacaoInutilizavel = observacaoInutilizavel;
        this.quantidadeEmprestada = quantidadeEmprestada;
        this.produto = produto;
        this.lotes = lotes;
    }
}